import * as PIXI from "pixi.js";

export function loadContainer({ parent, useParticleContainer = false }) {
  let container;
  if (useParticleContainer) {
    container = new PIXI.particles.ParticleContainer();
  } else {
    container = new PIXI.Container();
  }
  parent.addChild(container);

  return container;
}
